export const generateTimeSlots = (start, end) => {
    const times = [];
    for (let hour = start; hour <= end; hour++) {
      const formattedHour = hour.toString().padStart(2, "0");
      times.push(`${formattedHour}:00`);
    }
    return times;
};